<form [formGroup]="form">
  <div class="room-box">
    <i
      *ngIf="isEdit()"
      (click)="onDeleteRoom()"
      matTooltip="Remove Room"
      i18n-matTooltip
      i18n-matTooltip
      matTooltipClass="text-center"
      matTooltipPosition="above"
      class="fal fa-trash-alt"
    ></i>
    <i
      *ngIf="!isEdit()"
      matTooltip="Remove Room"
      i18n-matTooltip
      i18n-matTooltip
      matTooltipClass="text-center"
      matTooltipPosition="above"
      (click)="remove.emit(index)"
      class="fal fa-trash-alt"
    ></i>

    <div class="room-description-box">
      <mat-form-field class="mat-block name-block">
        <input matInput type="text" formControlName="name" placeholder="Room Name:" i18n-placeholder required />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
          Room Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mat-block type-block">
        <mat-select formControlName="type" placeholder="Room Type:" i18n-placeholder required>
          <mat-option value="bedroom" i18n>Bedroom</mat-option>
          <mat-option value="bathroom" i18n>Bathroom</mat-option>
          <mat-option value="kitchen" i18n>Kitchen</mat-option>
          <mat-option value="living" i18n>Living</mat-option>
          <mat-option value="general" i18n>General</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
          Room Type is required
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="hasSubType()" class="mat-block sub-type-block">
        <mat-select
          formControlName="sub_type"
          placeholder="Room Sub Type:"
          i18n-placeholder
          [required]="isRequired(form.get('sub_type'))"
        >
          <mat-option *ngFor="let type of roomTypes[getRoomType()]" [value]="type.id">{{ type.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('sub_type').touched && form.get('sub_type').hasError('required')" i18n>
          Room Sub Type is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="main-box">
      <div class="room-details-box">
        <mat-form-field class="mat-block size-metric-block">
          <mat-select formControlName="size_metric" placeholder="Size Metric" i18n-placeholder required>
            <mat-option value="SQFT" i18n>SQFT</mat-option>
            <mat-option value="SQM" i18n>SQM</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('size_metric').touched && form.get('size_metric').hasError('required')" i18n>
            Size Metric is required
          </mat-error>
        </mat-form-field>

        <mat-form-field class="mat-block size-block">
          <input type="text" matInput formControlName="size" placeholder="Size ({{ getSizeMetric() }}):" required />
          <mat-error *ngIf="form.get('size').touched && form.get('size').hasError('required')" i18n>
            Size is required
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="canAttachBathroom()" class="mat-block">
          <mat-select
            formControlName="bathroom"
            matTooltip='Some channels require at least one bathroom to be set and associated to a room. Please create a room of Room Kind "Bathroom" and associate it to some other room by selecting it on "Attached Bathroom" field'
            i18n-matTooltip
            placeholder="Attached Bathroom:"
            i18n-placeholder
          >
            <mat-option [value]="null" i18n>None</mat-option>
            <mat-option *ngFor="let bathroom of bathrooms" [value]="bathroom.pkey">{{ bathroom.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="mat-block description-block">
          <textarea
            matInput
            maxlength="500"
            rows="4"
            formControlName="description"
            placeholder="Room Description:"
            i18n-placeholder
            required
          ></textarea>
          <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('required')" i18n>
            Room Description is required
          </mat-error>
          <mat-hint align="end">{{ form.get('description').value?.length || 0 }}/500</mat-hint>
        </mat-form-field>
      </div>

      <div *ngIf="hasBeds()" class="beds-box">
        <div formArrayName="beds">
          <ng-container *ngFor="let room of bedsArray.controls; let i = index">
            <ng-container [formGroupName]="i">
              <div class="bed-row">
                <button (click)="removeBed(i)" class="btn btn-danger text-uppercase remove-bed-btn" type="button">
                  <i class="fal fa-minus"></i>
                </button>
                <mat-form-field class="mat-block">
                  <mat-select formControlName="bed" placeholder="Beds:" i18n-placeholder>
                    <mat-option *ngFor="let type of bedTypes" [value]="type.id">{{ type.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <button (click)="decrement(i)" class="btn btn-danger text-uppercase bed-btn-decrement" type="button">
                  <i class="fal fa-minus"></i>
                </button>
                <span class="bed-count">{{ room['controls'].count.value }}</span>
                <button (click)="increment(i)" class="btn btn-success text-uppercase bed-btn-increment" type="button">
                  <i class="fal fa-plus"></i>
                </button>
              </div>
            </ng-container>
          </ng-container>
          <div class="d-flex items-center">
            <button (click)="addBed()" class="btn btn-success text-uppercase add-bed-btn mr-2" type="button" i18n>
              Add Bed
            </button>
            <app-page-help articleId="d0sty819f7" tooltipText="Click here to see bed mapping with VRBO"></app-page-help>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
